module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/language'));
  PluginManager.registerAudienceMatcher('language', require('./matchers/language'));
};
